export const GAPageView = () => {
  const dataLayer = window.dataLayer || []
  window.userId && dataLayer.push({
    user_id: window.userId,
  })
}
